import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  ImageBackground,
  StyleSheet,
  Dimensions,
  Pressable,
  BackHandler,
  ScrollView,
  Platform,
} from "react-native";
import { RootState, useSelector } from "../../../redux/store";
import { fetchData } from "../../../services/Booking/bookingService";
import BookingsImages from "../../../assets/StaticImages/BookingsImages";
import BookingsIcons from "../../../assets/Icons/BookingsIcons";
import GlobalStyles from "../../../globalStyles/globalStyles";
import Tab from "./components/Tab";
import BookingStatusCard from "./components/BookingStatusCard";
import data from "../../../utils/countries";
import Brand from "../../../assets/Icons/BrandIcons";
import CardEmpty from "./components/CardEmpty";
import dimensions from "../../../globalStyles/dimensions";

interface Experience {
  id: string;
  name: string;
  title: string;
  bookingSlot: string;
  location: string;
  image: string;
  startTime: string;
  endTime: string;
}

interface Booker {
  id: string;
  name: string;
  phoneNumber: number;
  countryCode: string;
}

interface DataItem {
  experience: Experience;
  booker: Booker;
  _id: string;
  bookingId: string;
  chatId: string;
  bookedFor: string;
  participants: string[];
  bookingStatus: string;
  paymentStatus: string;
  adminReviewed: boolean;
  experienceReview: any[]; // Assuming it's an array of any type
  createdAt: string;
  updatedAt: string;
  __v: number;
  adminCancellationReason: string;
}

const initialData: DataItem[] = [];

export default function Bookings({ navigation }: { navigation: any }) {
  const { userToken } = useSelector((state: RootState) => state.user);

  const [status, setStatus] = useState("confirmed");
  const [confirmedData, setConfirmedData] = useState<DataItem[]>([]);
  const [pendingData, setPendingData] = useState<DataItem[]>([]);
  const [cancelledData, setCancelledData] = useState<DataItem[]>([]);
  // Filtering data based on bookingStatus
  const filterDataByStatus = (status: string, fetchedData: DataItem[]) => {
    return fetchedData.filter(
      (item) => item.bookingStatus.toLowerCase() === status.toLowerCase()
    );
  };
  const fetchDataAndSetState = async () => {
    try {
      const fetchedData = await fetchData(userToken);
      setConfirmedData(filterDataByStatus("confirmed", fetchedData));
      setPendingData(filterDataByStatus("pending", fetchedData));
      setCancelledData(filterDataByStatus("cancelled", fetchedData));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchDataAndSetState();
  }, []);
  
  const handleStatus = (value: any) => {
    setStatus(value);
  };

  return (
    <View
      style={{
        backgroundColor: "white",
      }}
    >
      <View>
        <ImageBackground
          source={BookingsImages.MyBookings}
          style={{
            height:  Dimensions.get('window').height / 3,
            width: Dimensions.get('window').width,
          }}
        >
          <View  style={{
              position: "absolute",
              top:40,
              left:20
            }}>
          <Pressable
            onPress={() => {
              navigation.goBack();
            }}
          >
            <View
              style={{
                width: Platform.OS === "web" ? 28 : 28,
                height: Platform.OS === "web" ? 24 : 24,
              }}
            >
              <BookingsIcons.MyBookingsIcon />
            </View>
          </Pressable>
          <View style={{ top: 50}}>
            <Text
              style={[GlobalStyles.heading2, { lineHeight: 42, fontSize: 36 }]}
            >
              My {"\n"}bookings
            </Text>
          </View>
          </View>
        </ImageBackground>
      </View>

      {/* bookings tab */}
      <Tab handleStatus={handleStatus} status={status} />

      {/* bookings content */}
      <ScrollView 
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          height: dimensions.windowHeight
        }}
      >
          {status === "confirmed" ? (
            <>
              {confirmedData.length != 0 ? (
                <BookingStatusCard data={confirmedData} />
              ) : (
                <CardEmpty text={"You have no confirmed bookings"} />
              )}
            </>
          ) : status === "pending" ? (
            <>
              {pendingData.length != 0 ? (
                <BookingStatusCard data={pendingData} />
              ) : (
                <CardEmpty text={"You have no pending bookings"} />
              )}
            </>
          ) : status === "cancelled" ? (
            // <BookingStatusCard data={cancelledData} />
            <>
              {cancelledData.length != 0 ? (
                <BookingStatusCard data={cancelledData} />
              ) : (
                <CardEmpty text={"You have no cancelled bookings"} />
              )}
            </>
          ) : (
            <View>
              <Text>Something went wrong in status</Text>
            </View>
          )}
      </ScrollView>
    </View>
  );
}

